import styled from "styled-components";
import { IoPlayCircle } from "react-icons/io5";
import { useRecoilValue } from "recoil";

import "./index.css";

import { IClip } from "MVVM/@types";
import { Button } from "MVVM/Components/Button";
import { PlaylistIdState } from "MVVM/State/embeddablePlaylist";
import { PlatformState } from "MVVM/State/iframe";

export const NotificationButton = ({ clip }: { clip: IClip }) => {
  const platform = useRecoilValue(PlatformState);
  const playlistId = useRecoilValue(PlaylistIdState);
  return (
    <StyledButton
      className="notification-button"
      size="small"
      flex={true}
      classification="primary"
      onClick={() => {
        const ajs_aid = window.rudderanalytics?.getAnonymousId() || "";
        const clipUrl = `/clip/${clip.shareId}?context=playlist&playlistId=${playlistId}&tab=recommended&utm_source=${platform}&ajs_aid=${ajs_aid}`;

        window.open(clipUrl, "_blank");
      }}
    >
      <StyledPlayCircle className="play-circle-icon" />
      Watch More
    </StyledButton>
  );
};

const StyledButton = styled(Button)`
  container-type: inline-size;
  container-name: notification-button;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.envy};
  border-radius: 20px;
  cursor: pointer;
  display: flex;
  font-size: 12px;
  font-weight: 500;
  height: 1.75rem;
  justify-content: center;
  padding: 0px 10px;
  pointer-events: auto;
  position: absolute;
  right: 10px;
  top: 15px;
  width: 126px;
`;

const StyledPlayCircle = styled(IoPlayCircle)`
  color: white;
  height: 14px;
  margin-right: 5px;
  width: 14px;
`;
